import React, { type FC, useRef } from 'react';
import { type FieldValues, useForm } from 'react-hook-form';
import { Toast } from 'primereact/toast';
import api from '../services/api';
import { setUsername, useUsername } from '../redux';

const ForgotPasswordForm: FC<{
    setForgotPassword: (value: boolean) => void;
}> = ({ setForgotPassword }) => {
    const toast = useRef<Toast>(null);
    const username = useUsername();

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const onSubmit = async (data: FieldValues) => {
        const { success, message } = await api.forgotPassword(
            data.email as string,
        );
        if (success) {
            setUsername(data.email as string);
            toast.current?.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Password Reset Email Sent',
            });
            setTimeout(() => {
                setForgotPassword(false);
            }, 1000);
        } else {
            toast.current?.show({
                severity: 'warn',
                summary: 'Password Reset Failed',
                detail: message ?? 'unknown error',
            });
        }
    };

    return (
        <div className="w-full h-full flex justify-center items-center">
            <Toast ref={toast} position="top-right" />
            <form
                className="flex flex-col justify-center items-center"
                onSubmit={handleSubmit(onSubmit)}
            >
                <input
                    placeholder="email"
                    defaultValue={username}
                    {...register('email', { required: true })}
                    className="input input-bordered input-primary text-primary m-2"
                />
                {errors.email && (
                    <span className="text-red-500 mb-2">
                        This field is required
                    </span>
                )}
                <p
                    className="text-primary underline cursor-pointer"
                    onClick={() => {
                        setForgotPassword(false);
                    }}
                >
                    Login
                </p>
                <button type="submit" className="btn btn-primary m-2">
                    Send Password Reset Email
                </button>
            </form>
        </div>
    );
};

export default ForgotPasswordForm;
